import { Grid  } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findUserHolding } from "../../redux/action/userActions";
import { getLocalStorage } from "../../utils/localStorage";
import { Buy } from "../Windows/Buy";
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Sell } from "../Windows/Sell";
import {  useSnackbar } from 'notistack';
import { orderreset } from "../../redux/action/orderActions";
import { SkeletonLoader } from "../Windows/Skeleton";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import { MenuDots } from "../Windows/MenuDots";
import { useTitle } from "../../context/TitleProvider";



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export const Holding = () => {
  const {setTitle} = useTitle()
  setTitle("Holdings")
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { userRedux, status, failedMessage } = useSelector(state => ({
    userRedux: state.userState.user,
    status: state.orderState.status,
    failedMessage: state.orderState.failedMessage
  }))
  

  const user = userRedux || getLocalStorage("user")
  const [holdings, setHoldings] = useState([]);
  const [instrumentForOrder, setInstrumentForOrder] = useState()
  const [open, setOpen] = useState(false)
  const [map, setMap] = useState(new Map());
  useEffect($ => {
    dispatch(findUserHolding(user.clientId, setHoldings, setMap))
  }, [ userRedux, user,  dispatch])



  useEffect($=>{
    status==="completed" &&  enqueueSnackbar('Order completed successfully', { variant : 'success' });
    status==="failed" &&  enqueueSnackbar( failedMessage, { variant : 'error' })
    return () => dispatch(orderreset());
 }, [status, dispatch, enqueueSnackbar, failedMessage])



  const handleOrderButton = (type, el) => {
    if (type === "buy") {
      setInstrumentForOrder({
        companyName: el,
        symbol: el,
        lastPrice: map.get(el),
      });
      setOpen("buy")
    }
    else {
      setInstrumentForOrder({
        companyName: el,
        symbol: el,
        lastPrice: map.get(el),
      });
      setOpen("sell")
    }
  }

  const totalInvested = holdings => holdings.reduce((total, instrument) => (instrument.price * instrument.quantity) + total, 0)
  const currentInvested = holdings => holdings.reduce((total, instrument) => ((map.get(instrument.instrument)) * instrument.quantity) + total, 0)
  const totalprofitloss =  (currentInvested(holdings) - totalInvested(holdings)).toFixed(2)
  const investedValue = el => (el.price * el.quantity).toFixed(2);
  const currentValue = el => (map.get(el.instrument) * el.quantity).toFixed(2);
  const profitLoss = el => (currentValue(el) - investedValue(el)).toFixed(2)
  const netchange = el => ((profitLoss(el)/investedValue(el))*100).toFixed(2);


  return <>    
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={4.5}>
          <Item>
            <b>
            Total Invested<br />
            {(totalInvested(holdings).toFixed(2))}
            </b>
          </Item>
        </Grid>
        <Grid item xs={4.5}>
          <Item>
          <b>
            Current Value<br />
            {(currentInvested(holdings).toFixed(2))}
            </b>
          </Item>
        </Grid>
        <Grid item xs={3}>
          <Item>
          <b style={{
                    color: totalprofitloss >= 0 ? "green" : "red"
                }}>
            P/L<br />
            {totalprofitloss}
            </b>
          </Item>
        </Grid>
        {isNaN(currentInvested(holdings)) ? <SkeletonLoader/>: <>
        <Table>
            <TableHead>
                       <TableCell>
                             Instrument
                         </TableCell>
                         <TableCell>
                             Qty.
                         </TableCell>
                         <TableCell>
                             Buy Price
                         </TableCell>
                         <TableCell>
                             LTP
                         </TableCell>
                         <TableCell>
                         Invested Value
                         </TableCell>
                         <TableCell>
                         Current Value
                        
                         </TableCell>
                         <TableCell>
                               P/L
                         </TableCell>
                         <TableCell>
                             Net Change
                         </TableCell>
            </TableHead>
            <TableBody>
                 {holdings.length !== 0 && holdings.map(el => {
             return  <TableRow key={el._id}>
                         <TableCell style={{display:"flex", textAlign:"center", alignItems: "center"}}>
                          
                         {el.instrument} <MenuDots instrument={el.instrument} handleOrderButton={handleOrderButton}/>
                         </TableCell>
                         <TableCell>
                         {el.quantity}
                         </TableCell>
                         <TableCell>
                         {el.price}
                         </TableCell>
                         <TableCell>
                         {map.get(el.instrument)}
                         </TableCell>
                         <TableCell>
                         {investedValue(el)}
                         </TableCell>
                         <TableCell>
                         {currentValue(el)}
                         </TableCell>
                         <TableCell style={{
                    color: profitLoss(el) >= 0 ? "green" : "red"
                  }}>
                    {profitLoss(el)}
                       </TableCell>
                       <TableCell style={{
                    color: profitLoss(el) >= 0 ? "green" : "red"
                  }}>
                         {netchange(el)}     
                         </TableCell>
                        
                     </TableRow>
                    })}
                          
                           
            </TableBody>
        </Table>
       
       </>}

      </Grid>
    </Box>


    {open === "buy" && <Buy setOpen={setOpen} user={user} instrument={instrumentForOrder} />}
    {open === "sell" && <Sell setOpen={setOpen} user={user} instrument={instrumentForOrder} />}
  </> 


}



